import { CssType, ThemeType } from 'src/theme/jss-types';

export const AddDriverStyle = (theme: ThemeType): CssType => ({
  formContainer: {
    '& .ant-form-item-label': {
      textAlign: 'left',
    },
    '& .ant-select, .ant-input, .ant-input-password': {
      width: '225px',
    },
  },
  actionButtons: {
    '& .ant-form-item-control-input-content': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  phoneInputWithCountry: {
    '& .react-tel-input .form-control': {
      width: '225px',
    },
  },
  cancelButton: {
    marginRight: '10px',
  },
  date: {
    width: '225px',
  },
});
